import { useMergeRefs } from '@floating-ui/react';
import { ChevronDown } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { DropdownWrapper } from "../dropdownWrapper/DropdownWrapper.js";
import { Input } from "../input/Input.js";
import styles from "./Dropdown.module.js";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const Dropdown = ({
  activeItem,
  filter,
  children,
  nullable,
  onSelection,
  onBlurFn,
  className,
  searchable,
  inputRef,
  autoSelect,
  appendTo,
  label,
  small,
  disabled,
  onFilterStringChange,
  noItemsHint,
  loading,
  favorites = [],
  readOnly,
  flip = false,
  ...props
}) => {
  return /*#__PURE__*/_jsx(DropdownWrapper, {
    options: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    }),
    onSelection: onSelection,
    autoSelect: autoSelect,
    activeItem: activeItem,
    filter: filter,
    nullable: nullable,
    className: className,
    appendTo: appendTo,
    small: small,
    offset: [0, 1],
    disabled: disabled,
    searchable: searchable,
    useChildAsButton: true,
    onBlurFn: onBlurFn,
    flip: flip,
    onFilterStringChange: onFilterStringChange,
    noItemsHint: noItemsHint,
    loading: loading,
    favorites: favorites,
    width: "REFERENCE",
    horizontalPadding: 32,
    readOnly: readOnly,
    children: ({
      handleFilterChange,
      value,
      open,
      ref,
      handleClick
    }) => {
      return /*#__PURE__*/_jsx(InnerInput, {
        ...props,
        className: classNames(styles.inputContainer, {
          [styles.searchable]: searchable,
          [styles.open]: open,
          [styles.disabled]: disabled,
          [styles.readOnly]: readOnly
        }),
        value: value,
        readOnlyWithStandardStyle: !searchable,
        readOnly: readOnly,
        onChange: handleFilterChange,
        icon: readOnly ? undefined : ChevronDown,
        inputRef: ref,
        label: label,
        small: small,
        disabled: disabled,
        iconClassName: styles.icon,
        onIconClick: handleClick
      });
    }
  });
};
function InnerInput({
  onClick,
  ...props
}) {
  const customInputRef = useRef(null);
  const mergedRefs = useMergeRefs([customInputRef, props.inputRef ?? null]);
  const onClickSelect = useCallback(e => {
    // Select the input text if the user clicks the input
    customInputRef.current?.setSelectionRange(0, customInputRef.current.value.length);
    onClick?.(e);
  }, [onClick]);
  return /*#__PURE__*/_jsx(Input, {
    ...props,
    onClick: onClickSelect,
    inputRef: mergedRefs ?? undefined
  });
}